export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11920.fa8becc5.jpg";